document.addEventListener('DOMContentLoaded', function() {
  // Wait for the page to fully load
  setTimeout(function() {
    // Check if we're on mobile
    if (window.innerWidth <= 768) {
      // Initialize Owl Carousel for advantages section
      if ($('.free__mobile').length) {
        $('.free__mobile').owlCarousel({
          loop: true,
          margin: 10,
          nav: true,
          dots: true,
          autoplay: false,
          navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
          responsive: {
            0: {
              items: 1,
              stagePadding: 30 // Show part of the next slide
            },
            576: {
              items: 1,
              stagePadding: 50
            }
          },
          onInitialized: function() {
            // Add swipe indicator after carousel is initialized
            if (!$('.swipe-indicator').length) {
              $('.free__mobile').after('<div class="swipe-indicator">Swipe to see more <span class="arrow">→</span></div>');
            }
            
            // Make sure navigation and dots are visible
            $('.free__mobile .owl-nav').css('display', 'block');
            $('.free__mobile .owl-dots').css('display', 'flex');
          }
        });
      }
    }
  }, 500); // Small delay to ensure all elements are properly loaded
});
